type HttpRequestTypes = "get";

// The format we receive api data in
export interface SwaggerJsonFile {
  paths: Record<
    string,
    Record<HttpRequestTypes, EndpointDetails & { [key: string]: unknown }>
  >;
  tags?: Tag[];
}

export interface Tag {
  name: string;
  description: string;
}

interface EndpointDetails {
  description: string;
  summary: string;
  tags: string[];
  deprecated?: boolean;
  "x-changeType"?: ApiChangeType;
  "x-changeDate"?: string;
  "x-changeNote"?: string;
}

// The format we convert api data to for easier handling
export interface ApiData {
  endpoints: Endpoint[];
  tags: Tag[];
}

export type ApiChangeType = "Create" | "Update";

export interface ApiChangeInfo {
  type: ApiChangeType;
  date: string;
  note?: string;
}

export interface Endpoint {
  url: string;
  summary: string;
  description: string;
  tags: string[];
  // The first tag is used for endpoint categorisation purposes.
  // Other tags are used for discoverability. See wiki page for more details:
  // https://elxnfa.visualstudio.com/Insights%20Solution/_wiki/wikis/Insights-Solution.wiki/7817/API?anchor=tagging
  changeInfo?: ApiChangeInfo;
}

// This must match with the NoSQL API implementation
export const I014TagValue = "SAA Settlement Reports (I014)";
